import React from 'react';

const ProfileDetailForm = ({ formData, onDataChange }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...formData, [name]: value };
    onDataChange(updatedData);
  };

  return (
    <div className="p-3">
      {/* 自己紹介文 */}
      <div className="mb-3 justify-content-start">
        <div className="col-12 d-flex mb-2 pl-0">
          <h3 className="mb-0" style={{ fontSize: '16px', fontWeight: 'bold' }}>
            自己紹介文
          </h3>
        </div>
        <textarea
          rows="4"
          className="form-control"
          placeholder="簡単な自己紹介文を記入してください"
          style={{ fontSize: '14px' }}
          name="introduction"
          value={formData.introduction || ''}
          onChange={handleChange}
        />
      </div>
      {/* 趣味/推しの詳細 */}
      {/* <div className="mb-3 justify-content-start">
        <div className="col-12 d-flex mb-2 pl-0">
          <h3 className="mb-0" style={{ fontSize: '16px', fontWeight: 'bold' }}>
            趣味/推しの詳細
          </h3>
          <p className="mb-0" style={{ fontSize: '12px' }}>
            　(趣味/推し活歴、きっかけ等)
          </p>
        </div>
        <textarea
          rows="4"
          className="form-control"
          placeholder="趣味や推しについて記入してください"
          style={{ fontSize: '14px' }}
          name="hobby_details"
          value={formData.hobby_details || ''}
          onChange={handleChange}
        />
      </div> */}

      {/* <div className="mb-4 justify-content-start">
        <div className="col-12 d-flex mb-2 pl-0">
          <h3 className="mb-0" style={{ fontSize: '16px', fontWeight: 'bold' }}>
            一緒にしたいこと
          </h3>
          <p className="mb-0" style={{ fontSize: '12px' }}>
            　(Myイベントも活用しよう！)
          </p>
        </div>
        <textarea
          rows="4"
          className="form-control"
          placeholder="趣味や推しについて記入してください"
          style={{ fontSize: '14px' }}
          name="activity_wishes"
          value={formData.activity_wishes || ''}
          onChange={handleChange}
        />
      </div> */}

      <div className="mb-4 justify-content-start">
        <div className="col-12 d-flex mb-2 pl-0">
          <h3 className="mb-0" style={{ fontSize: '16px', fontWeight: 'bold' }}>
            こんな趣味活/推し活友達がほしい
          </h3>
        </div>
        <textarea
          rows="4"
          className="form-control"
          placeholder="趣味や推しについて記入してください"
          style={{ fontSize: '14px' }}
          name="friend_preferences"
          value={formData.friend_preferences || ''}
          onChange={handleChange}
        />
      </div>

      {/* プロフィール設定 */}
      <div className="p-2 mb-3">
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '10px',
            borderSpacing: 0,
            borderTop: '1px solid #e0e0e0',
            borderBottom: '1px solid #e0e0e0',
          }}
        >
          <tr>
            <td
              style={{
                padding: '10px 12px',
                fontSize: '14px',
                color: '#555',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <img
                src="/assets2019/img/profile/voice_selection.svg"
                alt="タメ口"
                style={{ width: '20px', height: '20px', marginRight: '8px' }}
              />
              タメ口
            </td>
            <td style={{ textAlign: 'right', padding: '10px 15px' }}>
              <select
                name="casual_talk_preference"
                value={formData.casual_talk_preference || ''}
                onChange={handleChange}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '14px',
                  padding: 0,
                  cursor: 'pointer',
                  width: 'auto',
                }}
              >
                <option value=""></option>
                <option value="1">歓迎</option>
                <option value="2">普通</option>
                <option value="3">苦手</option>
              </select>
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: '10px 12px',
                fontSize: '14px',
                color: '#555',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <img
                src="/assets2019/img/profile/diversity.svg"
                alt="ファン同士の交流"
                style={{ width: '20px', height: '20px', marginRight: '8px' }}
              />
              ファン同士の交流
            </td>
            <td style={{ textAlign: 'right', padding: '10px 15px' }}>
              <select
                name="fan_interaction_preference"
                value={formData.fan_interaction_preference || ''}
                onChange={handleChange}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '14px',
                  padding: 0,
                  cursor: 'pointer',
                  width: 'auto',
                }}
              >
                <option value=""></option>
                <option value="1">歓迎</option>
                <option value="2">普通</option>
                <option value="3">苦手</option>
              </select>
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: '10px 12px',
                fontSize: '14px',
                color: '#555',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <img
                src="/assets2019/img/profile/volunteer_activism.svg"
                alt="趣味/推しの布教"
                style={{ width: '20px', height: '20px', marginRight: '8px' }}
              />
              趣味/推しの布教
            </td>
            <td style={{ textAlign: 'right', padding: '10px 15px' }}>
              <select
                name="hobby_promotion_preference"
                value={formData.hobby_promotion_preference || ''}
                onChange={handleChange}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '14px',
                  padding: 0,
                  cursor: 'pointer',
                  width: 'auto',
                }}
              >
                <option value=""></option>
                <option value="1">歓迎</option>
                <option value="2">普通</option>
                <option value="3">苦手</option>
              </select>
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: '10px 12px',
                fontSize: '14px',
                color: '#555',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <img
                src="/assets2019/img/profile/theater_comedy.svg"
                alt="同行"
                style={{ width: '20px', height: '20px', marginRight: '8px' }}
              />
              同行
            </td>
            <td style={{ textAlign: 'right', padding: '10px 15px' }}>
              <select
                name="accompanying_preference"
                value={formData.accompanying_preference || ''}
                onChange={handleChange}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '14px',
                  padding: 0,
                  cursor: 'pointer',
                  width: 'auto',
                }}
              >
                <option value=""></option>
                <option value="1">希望</option>
                <option value="2">希望していない</option>
              </select>
            </td>
          </tr>
        </table>
      </div>
      <div className="mb-3">
        <h3 style={{ fontSize: '16px', fontWeight: 'bold' }}>プロフィール</h3>
        <div className="form-group">
          <label style={{ fontSize: '14px' }}>
            {/* 年齢幅を公開しますか？（年齢、又は年齢幅を公開する場合、募集一覧項目への掲載、または他の人の募集一覧を見ることができます） */}
            年齢幅を公開しますか？（年齢、又は年齢幅を公開する場合、Myイベント一覧項目への掲載、または他の人のイベントを見ることができます）
          </label>
          <select
            className="form-control"
            style={{ fontSize: '14px' }}
            name="age_range_visibility"
            value={formData.age_range_visibility || ''}
            onChange={handleChange}
          >
            <option value=""></option>
            <option value="1">する</option>
            <option value="2">しない</option>
          </select>
        </div>
        <div className="form-group">
          <label style={{ fontSize: '14px' }}>活動拠点（公開したくない場合は未選択のままにしてください）</label>
          <select
            className="form-control"
            style={{ fontSize: '14px' }}
            name="activity_base"
            value={formData.activity_base || ''}
            onChange={handleChange}
          >
            <option value=""></option>
            <option value="東京">東京</option>
            <option value="関東">関東</option>
            <option value="北海道">北海道</option>
            <option value="東北">東北</option>
            <option value="中部">中部</option>
            <option value="近畿">近畿</option>
            <option value="中国">中国</option>
            <option value="四国">四国</option>
            <option value="九州">九州</option>
            <option value="沖縄">沖縄</option>
            <option value="その他">その他</option>
          </select>
        </div>
      </div>
    </div>    
  );
};

export default ProfileDetailForm;